import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizePreClaimsFullReleaseList } from './normalize';

export const fetchPreClaimsFullReleaseList = createProvider(api.fetchPreClaimsFullReleaseList)
  .andThen((res) => normalizePreClaimsFullReleaseList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
